<template>
  <div>
    <el-dialog
      v-model="dialogFormVisible"
      :close-on-click-modal="false"
      :title="title"
      width="80%"
      @close="close"
    >
      <el-form ref="form" label-width="120px" :model="form" :rules="rules">
        <el-form-item label="标题" prop="title">
          <el-input
            v-model.trim="form.title"
            class="fix-width"
            placeholder="请输入标题"
          />
        </el-form-item>
        <el-form-item label="封面" prop="avatar">
          <el-upload
            class="avatar-uploader"
            :show-file-list="false"
            :action="QNUploadURL"
            :data="uploadToken"
            :on-success="image_success"
            :on-remove="image_remove"
          >
            <img v-if="form.avatar" :src="form.avatar" class="avatar" />
            <i v-else class="avatar-uploader-icon el-icon-plus"></i>
          </el-upload>
          <span>建议尺寸：256px * 256px</span>
        </el-form-item>
        <!-- 标签列表 -->
        <el-form-item label="标签" prop="tagIdList">
          <el-cascader
            :props="cascaderProps"
            placeholder="请选择标签"
            id="cascader"
            v-model="form.tagIdList"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            type="textarea"
            v-model="form.text"
            class="fix-width"
            placeholder="备注"
          />
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="form.order" placeholder="排序" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="save">确 定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { createItem, updateItem, findTagAll } from '@/api/mediaLibrary'
import { getUploadToken } from '@/api/app'
import { QNUploadURL, QNHost } from '@/config/net.config'
export default {
  name: 'MediaItemEdit',
  emits: ['fetch-data'],
  data() {
    return {
      title: '',
      QNUploadURL,
      QNHost,
      uploadToken: null,
      form: {
        itemId: '',
        title: '',
        tagIdList: [],
        avatar: '',
        text: '',
        order: 1,
      },
      rules: {
        title: [{ required: true, trigger: 'blur', message: '请输入标题' }],
        avatar: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (value=='') {
                callback(new Error('请上传封面'))
              } else {
                callback()
              }
            },
          },
        ],
        tagIdList: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (value.length == 0) {
                callback(new Error('请选择标签'))
              } else {
                callback()
              }
            },
          },
        ],
      },
      dialogFormVisible: false,
      cascaderProps: {
        lazy: true,
        checkStrictly: true,
        async lazyLoad(node, resolve) {
          const { level } = node
          const { value } = node.data
          console.log('node', node)
          if (level == 0) {
            const list = (await findTagAll({ level: level + 1 })).map(
              (item) => ({
                value: item.tagId,
                label: item.basic.title,
                // leaf: level >= 2,
              })
            )
            resolve(list)
          }else {
            const list = (await findTagAll({ parentTagId: value })).map(
              (item) => ({
                value: item.tagId,
                label: item.basic.title,
                // leaf: level >= 2,
              })
            )
            resolve(list)
          }
        },
      },
    }
  },
  methods: {
    async showEdit(row) {
      if (row) {
        this.title = '修改物件'
        this.form = Object.assign(this.form, row.basic)
        this.form.itemId = row.itemId
        this.form.title = row.title
      } else {
        this.title = '新增物件'
      }
      this.dialogFormVisible = true
      const token = await getUploadToken({})
      this.uploadToken = { token: token.token }
    },
    // 图片
    image_remove(file, fileList) {
      this.form.avatar = ''
    },
    image_success(res, file) {
      if (!res.hash) {
        this.$message.error('图片上传失败')
        return
      }
      this.form.avatar = `${QNHost}/${res.hash}`
    },
    close() {
      this.$refs['form'].resetFields()
      this.form = this.$options.data().form
      this.dialogFormVisible = false
    },
    save() {
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          const itemId = this.form.itemId
          const data = Object.assign({}, this.form)
          this.$baseConfirm(
            `你确定要${itemId ? '修改' : '新增'}物件吗`,
            null,
            async () => {
              itemId ? await updateItem(data) : await createItem(data)
              this.$baseMessage(
                `${itemId ? '修改' : '新增'}物件成功`,
                'success',
                false,
                'vab-hey-message-success'
              )
              this.$emit('fetch-data')
              this.close()
            }
          )
        } else {
          return false
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@mixin size($scale: 1, $type: small) {
  @if $type == large {
    width: 343px * $scale;
  } @else {
    width: 167px * $scale;
  }
  height: 167px * $scale;
}
.avatar-uploader {
  .avatar {
    border-radius: 6px;
    transition: all 0.3s ease-in-out;
    @include size;

    &.large {
      @include size(1, large);
    }
  }
}
.icon_avatar {
  width: 50px;
  height: 50px;
}
.avatar-uploader-icon {
  border: 1px dashed #c0ccda;
  background-color: #fbfdff;
  border-radius: 6px;
  font-size: 28px;
  color: #8c939d;
  width: 148px;
  height: 148px;
  line-height: 148px;
  text-align: center;
}
.tags {
  margin-bottom: 5px;
}
.tags + .tags,
.tags + .button-new-tag {
  margin-left: 10px;
}
.button-new-tag {
  // margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
.disabled .el-upload--picture-card {
  display: none;
}
.fix-width {
  width: 500px;
}
.mb-10 {
  margin-bottom: 10px;
}
.tips {
  color: #aaaaaa;
  margin-left: 50px;
}
.el-icon-circle-plus-outline,
.el-icon-remove-outline {
  font-size: 32px;
  vertical-align: middle;
  cursor: pointer;
}

.el-icon-circle-plus-outline {
  color: #409eff;
}

.el-icon-remove-outline {
  color: #f56c6c;
  margin-left: 15px;
}
#cascader {
  width: 500px !important;
}
::v-deep .el-cascader {
  width: 500px;
}
</style>
